var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileFrameSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 383 780",
    enableBackground: "new 0 0 383 780",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M383,191h-1.5V49.9c0-27.5-22.4-49.9-49.9-49.9H51.4C23.9,0,1.5,22.4,1.5,49.9v51.6H0V132h1.5v24.3H0v60.6 h1.5v16.9H0v60.6h1.5v435.7c0,27.5,22.4,49.9,49.9,49.9h280.2c27.5,0,49.9-22.4,49.9-49.9V290h1.5V191z M214.5,27.5 c0,2.1-1.7,3.8-3.8,3.8h-38.5c-2.1,0-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8h38.5C212.8,23.8,214.5,25.4,214.5,27.5z M369.5,730.1 c0,20.9-17,37.9-37.9,37.9H51.4c-20.9,0-37.9-17-37.9-37.9V49.9C13.5,29,30.5,12,51.4,12h43.4v13.3c0,10.9,8.8,19.7,19.7,19.7h154 c10.9,0,19.7-8.8,19.7-19.7V12h43.4c20.9,0,37.9,17,37.9,37.9V730.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFrameSvg);
export default __webpack_public_path__ + "static/media/mobile_frame_svg.bd306644e0cd7a8703982c51b3b68328.svg";
export { ForwardRef as ReactComponent };